import { Component, DestroyRef, OnInit, ViewChild, ViewContainerRef, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { filter } from 'rxjs/operators';
import { ToolbarConfig, ToolbarTitleAction } from './interfaces';
import { ToolbarService } from './toolbar.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-toolbar',
  templateUrl: 'toolbar.component.html',
  styleUrls: ['./toolbar.component.scss'],
})
export class ToolbarComponent implements OnInit {
  @ViewChild('titleAction', { read: ViewContainerRef }) private titleAction?: ViewContainerRef;
  toolbarConfig$: Observable<ToolbarConfig>;
  private destroyRef = inject(DestroyRef);

  constructor(private toolbarService: ToolbarService) {}

  ngOnInit(): void {
    this.toolbarConfig$ = this.toolbarService.toolbarConfig$.pipe(
      filter((config) => !!config),
      takeUntilDestroyed(this.destroyRef),
    );
    this.toolbarConfig$.subscribe((config) => {
      this.setTitleAction(config?.titleAction);
    });
  }

  private setTitleAction(titleAction: ToolbarTitleAction): void {
    this.titleAction?.clear();
    if (titleAction) {
      this.titleAction?.createEmbeddedView(titleAction);
    }
  }
}
